<template>
  <v-row>
    <v-col cols="12" :sm="colsSm(config)" :md="colsMd(config)" v-for="(newsItem, i) in news" :key="i">
      <v-card flat>
        <v-divider class="mb-4"></v-divider>
        <v-img style="border-radius: 0" :height="imgHeight" v-if="teaserExists(newsItem)" :src="teaserUrl(newsItem)"> </v-img>
        <v-card-title class="px-0" style="white-space: pre-line">{{ newsItem.title }}</v-card-title>
        <v-card-text class="px-0" v-html="newsItem.content"></v-card-text>
        <v-card-text class="px-0 pb-10"
          ><div class="caption">Aktualisiert am {{ localeDateFromString(newsItem.dateupdated) }}</div>
          <div class="caption">Geschrieben am {{ localeDateFromString(newsItem.datecreated) }}</div></v-card-text
        >
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import config from '@/common/config';
import { mapState } from 'vuex';
import dateUtils from '@/common/dateUtils';
import viewUtils from '@/common/viewUtils';
export default {
  name: 'NewsSelection',
  props: {
    config: {
      type: Object,
    },
  },

  computed: {
    news() {
      if (this.sectionConfig.NewsSelectionConfig.selection) {
        const { selectorLabel, latestItems } = this.sectionConfig.NewsSelectionConfig.selection;
        let news;
        if (selectorLabel || latestItems) {
          news = this.$store.state.news.news.filter((item) => {
            if (selectorLabel) {
              if (item.labels) {
                let matches = item.labels.filter((i) => i.label === selectorLabel);
                return matches.length > 0;
              }
              return false;
            }
            return true; // accept since no selectorLabel is defined
          });
        } else {
          news = this.$store.state.news.news;
        }
        news.sort((a, b) => dateUtils.compareISOStringDates(a.dateupdated, b.dateupdated)).reverse();
        if (latestItems) {
          return news.splice(0, latestItems);
        }
        return news;
      }
      return this.$store.state.news.news;
    },
    ...mapState({
      newsById: (state) => state.news.newsById,
      token: (state) => state.profile.user.token,
    }),
    imgHeight() {
      return this.news.length < 3 ? 300 : 150;
    },
  },

  methods: {
    parse(dateString) {
      return dateUtils.parse(dateString);
    },
    localeDateFromString(dateString) {
      let date = dateUtils.parseISOString(dateString);
      if (date && typeof date.getMonth === 'function') {
        return dateUtils.formatAsLocaleDateTime(date);
      }
    },
    teaserExists(newsItem) {
      if (newsItem && newsItem.medias) {
        return newsItem.medias.filter((media) => media.type === 'teaser').length > 0;
      }
      return false;
    },
    teaserUrl(newsItem) {
      let teasers = newsItem.medias.filter((media) => media.type === 'teaser');
      if (teasers.length > 0) {
        return `${config.apiUrl}/medias/news/${teasers[0].filename}/${teasers[0].checksum}?token=${this.token}`;
      }
      return '';
    },

    colsMd(sectionConfig) {
      return viewUtils.colsMd(sectionConfig.layoutMaxCols, this.news);
    },
    colsSm(sectionConfig) {
      return viewUtils.colsSm(sectionConfig.layoutMaxCols, this.news);
    },
  },
};
</script>
